import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = 'Hydro Health Peptides';

const TITLES = {
  '/': 'Hydro Health Peptides \u2014 Lab-Tested Research Peptides',
  '/shop': `Shop Research Peptides \u2014 ${BASE}`,
  '/about': `About Us \u2014 ${BASE}`,
  '/coas': `Lab Tested COAs \u2014 ${BASE}`,
  '/news': `News & Updates \u2014 ${BASE}`,
  '/contact': `Contact \u2014 ${BASE}`,
  '/track': `Track Your Order \u2014 ${BASE}`,
  '/cart': `Cart \u2014 ${BASE}`,
  '/checkout': `Checkout \u2014 ${BASE}`,
  '/account': `My Account \u2014 ${BASE}`,
};

const DESCRIPTIONS = {
  '/': 'Lab-tested research peptides with full COA documentation. Worldwide shipping. For laboratory research use only.',
  '/shop': 'Browse our full range of research-grade peptides. All \u226599% purity with third-party Certificates of Analysis.',
  '/about': 'Hydro Health delivers research-grade quality with no shortcuts \u2014 independently verified, transparently documented.',
  '/coas': 'Every Hydro Health peptide ships with a batch-specific Certificate of Analysis. Search the database.',
  '/news': 'Latest news, releases and lab updates from Hydro Health Peptides.',
  '/contact': 'Contact Hydro Health Peptides for product or order enquiries.',
};

const setMeta = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setOg = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const SEO = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Pick best matching key (prefix for /product/:slug)
    const key = pathname.startsWith('/product/') ? '/shop' : pathname;
    const title = TITLES[key] || BASE;
    const desc = DESCRIPTIONS[key] || DESCRIPTIONS['/'];
    document.title = title;
    setMeta('description', desc);
    setOg('og:title', title);
    setOg('og:description', desc);
    setOg('og:url', `https://hydrohealth.store${pathname}`);
    setCanonical(`https://hydrohealth.store${pathname}`);
  }, [pathname]);
  return null;
};

export default SEO;
